import _ from "lodash";
import React, { createRef, useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import NextArrow from "../../LearningPaths/NextArrow";
import PrevArrow from "../../LearningPaths/PrevArrow";

import StaticUtils from "../../../utils/StaticUtils";
import * as XLSX from "xlsx";

import { useNavigate } from "react-router-dom";
import moment from "moment";
import PaginationProgress from "../progressReport/PaginationProgress";
import NotFoundImage from "../../NewDesign/NotFound/NotFoundImage";

const fileName = "SystemUsageReport";
const exportType = "xls";
// let PageSize = 20;
const sliderRef = createRef();
const settings = {
  slidesToShow: 1,
  slidesToScroll: 1,
  autoplay: false,
  dots: true,
  arrows: true,
  autoplaySpeed: 2000,
  infinite: false,
  centerMode: false,
  swipe: false,
  prevArrow: <PrevArrow />,
  nextArrow: <NextArrow />,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: true,
      },
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
      },
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
      },
    },
  ],
};
const LPSurveyTableComp = (props) => {
  const {
    setSearchInput,
    getFilteredData,
    setIsLoading,
    isLoading,
    isView,
    statusFilterData,
    setCanShow,
    type,
    profileReports,
    lpName,
    message,
    searchTable,
    pageNum,
    setPageNum,
    pageSize,
    setPageSize,
    searchInput,
    fetchData,
    totalRecords,
    isMobile,
  } = props;

  const dispatch = useDispatch();
  const profileReportRes = useSelector((state) => state.report.profileReport);
  const anyTotalReportRes = useSelector((state) => state.report.anyTotalReport);
  const authBroker = useSelector((state) => state.auth.authBroker);
  const authIframeBroker = useSelector((state) => state.auth.authIframeBroker);
  // const [profileReports, setProfileReports] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalRecord, setTotalRecord] = useState(0);
  const [legends, setLegends] = useState([]);
  const [series, setSeries] = useState([]);
  const [progressSort, setProgressSort] = useState("asc");
  const [searchedText, setsearchedText] = useState("");
  const [officeLabel, setOfficeLabel] = useState("");
  // const [pageSize, setPageSize] = useState(50);
  const [disableFooter, setDisableFooter] = useState(true);
  const [searchTerm, setSearchTerm] = useState("");

  let navigate = useNavigate();

  useEffect(() => {
    if (pageNum) {
      setCurrentPage(pageNum);
    }
  }, [pageNum]);

  useEffect(() => {
    if (!_.isEmpty(authBroker)) {
      if (
        !_.isEmpty(authBroker.payload?.user?.config) &&
        authBroker.payload?.user?.config.office_name
      ) {
        setOfficeLabel(authBroker.payload?.user?.config.office_name);
      } else {
        setOfficeLabel("Office Name");
      }
    }
  }, [authBroker]);

  useEffect(() => {
    if (!searchInput) {
      setSearchTerm("");
    }
  }, [searchInput]);

  useEffect(() => {
    if (!_.isEmpty(authIframeBroker)) {
      // alert(JSON.stringify(authIframeBroker.payload.user.config))
      if (
        !_.isEmpty(authIframeBroker.payload?.user?.config) &&
        authIframeBroker.payload?.user?.config.office_name
      ) {
        setOfficeLabel(authIframeBroker.payload?.user?.config.office_name);
      } else {
        setOfficeLabel("Office Name");
      }
    }
  }, [authIframeBroker]);

  // useEffect(() => {
  //   setCurrentPage(1);
  // }, [profileReports]);

  const currentTableData = useMemo(() => {
    console.log("check----1", profileReports);
    if (profileReports !== null) {
      console.log(profileReports);
      let reportsData = _.clone(profileReports);
      console.log(reportsData);
      // reportsData = _.sortBy(reportsData, "progress");
      // if (progressSort === "desc") {
      //   reportsData = _.reverse(reportsData);
      // }
      console.log(reportsData);
      // const firstPageIndex = (currentPage - 1) * pageSize;
      // const lastPageIndex = firstPageIndex + pageSize;
      // setCanShow(true);
      // console.log(reportsData);
      // return reportsData.slice(firstPageIndex, lastPageIndex);

      setDisableFooter(false);

      return reportsData;
    }
  }, [profileReports]);

  const ExportToExcel = () => {
    const data = _.cloneDeep(profileReports);
    for (let item of data) {
      item.status =
        item?.status === "In Progress"
          ? "In Progress"
          : item?.status === "NotStarted"
          ? "Yet to start"
          : "Completed";
      item.progress =
        item?.progress !== undefined && item?.progress !== ""
          ? item?.progress + "%"
          : "-";
      item.completion_date =
        item?.completion_date !== undefined && item?.completion_date !== ""
          ? moment(
              StaticUtils.getDateFromTimeStamp(item?.completion_date),
              "MM/DD/YYYY"
            ).format("DD MMM, YYYY")
          : "-";
    }

    let tempArr = [];
    for (const item of data) {
      let obj = {
        username: item.username,
        email: item.email,
        office_name: item.office_name,
        status: item.status,
        progress: item.progress,
        completion_date: item.completion_date,
      };
      tempArr.push(obj);
    }

    const newThing = [];
    tempArr.map((item) => {
      newThing.push(
        _.mapKeys(item, (value, key) => {
          switch (key) {
            case "username":
              return "Name";
            case "email":
              return "Email";
            case "office_name":
              return { officeLabel };
            case "status":
              return "Status";
            case "progress":
              return "% Progress";
            case "completion_date":
              return "Date of Completion";
            default:
              return;
          }
        })
      );
    });

    for (let i = 0; i < newThing.length; i++) {
      // arrayObj[i].stroke = arrayObj[i]['key1'];
      delete newThing[i].undefined;
    }

    for (let i = 0; i < data.length; i++) {
      // arrayObj[i].stroke = arrayObj[i]['key1'];
      delete data[i]._id;
    }
    // console.log('data:', data)
    // exportFromJSON({ data, fileName, exportType })

    //For mobile
    let tempObj = {
      method: "CodeOfEthicsReport",
      report: newThing,
    };
    if (window.callbackHandler != undefined) {
      window.callbackHandler.postMessage(JSON.stringify(tempObj));
    } else if (window.webkit != undefined) {
      if (window.webkit.messageHandlers.callbackHandler != undefined) {
        window.webkit.messageHandlers.callbackHandler.postMessage(
          JSON.stringify(tempObj)
        );
      }
    }

    const worksheet = XLSX.utils.json_to_sheet(newThing);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
    //let buffer = XLSX.write(workbook, { bookType: "xlsx", type: "buffer" });
    //XLSX.write(workbook, { bookType: "xlsx", type: "binary" });
    XLSX.writeFile(workbook, fileName + ".xlsx");
  };

  function formatDate(inputDate) {
    const dateParts = inputDate.split("/");

    // Check if the date format is valid
    if (dateParts.length !== 3) {
      return "";
    }

    const formattedDate = new Date(
      `${dateParts[2]}-${dateParts[0]}-${dateParts[1]}`
    );

    // Check if the constructed date is valid
    if (isNaN(formattedDate.getTime())) {
      return "";
    }

    const day = formattedDate.getDate();
    const monthNames = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ];
    const monthIndex = formattedDate.getMonth();
    const year = formattedDate.getFullYear();

    const formattedString = `${day} ${monthNames[monthIndex]}, ${year}`;

    return formattedString;
  }

  const navigateToSurveyDetail = (item) => {
    let id = item?.survey_template_id;

    let paramsReq = {
      entityId: item?.survey_id,
    };
    let string = JSON.stringify(paramsReq);
    let encod = btoa(string);
    let url = "";
    if (isMobile) {
      url = `/survey-generator-mobile/${id}?paramsObj=${encod}&canEdit=0&user_id=${item?.user_id}`;
    } else {
      url = `/survey-generator/${id}?paramsObj=${encod}&canEdit=0&user_id=${item?.user_id}`;
    }
    navigate(url);
  };

  const renderTableReport = () => {
    return (
      <div className="row list-coach report-table-rsp">
        <div className="col-lg-12 col-md-12">
          <div className="table-responsive-usage">
            <div className="tablebox">
              <table className="table mb-0 office_list table-striped">
                <thead>
                  <tr>
                    <th className="office-province">First Name</th>
                    <th className="office-province">Last Name</th>
                    <th className="office-province">Role</th>
                    <th className="office-province">Email</th>
                    <th className="office-province">{officeLabel}</th>
                    <th className="office-province">Manager</th>
                    <th className="office-province">LP Name</th>
                    <th className="office-province">Survey Name</th>
                    <th className="office-province">Survey Status</th>
                    <th className="office-province">Survey Completion Date</th>
                  </tr>
                </thead>
                <tbody>
                  {currentTableData?.map((item, index) => {
                    return (
                      <tr className="addBGcustomw">
                        <td>{item?.first_name}</td>
                        <td>{item?.last_name}</td>
                        <td>{item?.roles}</td>
                        <td>{item?.email}</td>
                        <td>{item?.office_name}</td>

                        <td>{item?.manager_name}</td>
                        <td>{item?.lp_name}</td>
                        <td
                          className={`${
                            item?.survey_status === "not-started"
                              ? ""
                              : "name-link cursor-pointer"
                          }`}
                          onClick={() => {
                            if (item?.survey_status !== "not-started") {
                              navigateToSurveyDetail(item);
                            }
                          }}
                        >
                          {item?.survey_name}
                        </td>
                        <td>
                          {item?.survey_status === "not-started"
                            ? "Yet to start"
                            : item?.survey_status === "completed"
                            ? "Completed"
                            : item?.survey_status}
                        </td>
                        <td
                          className={`${
                            item?.survey_completion_date ? "" : "text-center"
                          }`}
                        >
                          {item?.survey_completion_date
                            ? moment(item?.survey_completion_date).format(
                                "MMM DD, YYYY"
                              )
                            : "-"}
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>

            <div className="pagetab d-flex justify-content-center gap-2 mt-5 align-items-center">
              <div className="input-lear">
                <select
                  className="form-select mb-0"
                  disabled={disableFooter}
                  onChange={(evt) => {
                    if (!disableFooter) {
                      setDisableFooter(true);
                      setCurrentPage(1);
                      setPageNum(1);
                      setPageSize(_.toNumber(evt.target.value));
                    }
                  }}
                >
                  <option selected={pageSize === 20} value="20">
                    20
                  </option>
                  <option selected={pageSize === 50} value="50">
                    50
                  </option>
                  <option selected={pageSize === 100} value="100">
                    100
                  </option>
                </select>
              </div>
              <span className="rosetext">rows per page</span>
              <PaginationProgress
                className="pagination-bar m-0 cursor-not-allowed"
                disablePagination={disableFooter}
                currentPage={pageNum ? pageNum : 1}
                totalCount={totalRecords}
                pageSize={pageSize}
                onPageChange={(page) => {
                  console.log("PG NUMBER footer", disableFooter);
                  if (!disableFooter) {
                    setPageNum(page);
                    setDisableFooter(true);
                  }
                }}
              />
            </div>
          </div>
        </div>
      </div>
    );
  };

  return (
    <>
      <section className="table-report-layout mt-rem">
        {true ? (
          <div className="container">
            <div className="row">
              <div className="col-md-12">
                <div className="table-head">Details</div>
              </div>

              <div className="col-md-12 search__input mb-4">
                <div className="input-lear position-relative d-flex">
                  <label for="search" className="input__label_learning">
                    Search
                  </label>
                  <input
                    type="search"
                    id="search"
                    name="search"
                    className="input_searchfield_search mb-0"
                    autocomplete="off"
                    onChange={(evt) => {
                      if (searchTerm && !evt.target.value) {
                        setSearchInput("");
                        setPageNum(1);
                      }
                      setSearchTerm(evt.target.value);
                    }}
                    value={searchTerm}
                  />
                  <button
                    className="button-reset"
                    onClick={() => {
                      if (searchInput == searchTerm && searchTerm) fetchData();
                      setSearchInput(searchTerm);
                      setPageNum(1);
                    }}
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      xmlnsXlink="http://www.w3.org/1999/xlink"
                      id="Find"
                      width="28"
                      height="28"
                      viewBox="0 0 30 30"
                    >
                      <defs>
                        <linearGradient
                          id="linear-gradient"
                          y1="0.5"
                          x2="1"
                          y2="0.5"
                          gradientUnits="objectBoundingBox"
                        >
                          <stop offset="0" stop-color="#6941C6" />
                          <stop offset="1" stop-color="#ed156e" />
                        </linearGradient>
                      </defs>
                      <circle
                        id="Ellipse_191"
                        data-name="Ellipse 191"
                        cx="15"
                        cy="15"
                        r="15"
                        fill="url(#linear-gradient)"
                      />
                      <circle
                        id="Ellipse_192"
                        data-name="Ellipse 192"
                        cx="13"
                        cy="13"
                        r="13"
                        transform="translate(2 2)"
                        fill="#fff"
                      />
                      <path
                        id="Icon_awesome-search"
                        data-name="Icon awesome-search"
                        d="M14.372,12.6,11.535,9.762a.683.683,0,0,0-.484-.2h-.464a5.917,5.917,0,1,0-1.025,1.025v.464a.683.683,0,0,0,.2.484L12.6,14.372a.68.68,0,0,0,.965,0l.805-.805A.686.686,0,0,0,14.372,12.6ZM5.92,9.562A3.643,3.643,0,1,1,9.562,5.92,3.641,3.641,0,0,1,5.92,9.562Z"
                        transform="translate(7.715 7.714)"
                        fill="#6941C6"
                      />
                    </svg>
                  </button>
                </div>
              </div>
            </div>
            {currentTableData && currentTableData?.length > 0 ? (
              renderTableReport()
            ) : profileReports !== null ? (
              <div className="not-found mt-3">
                <div className=" interboxes">
                  <NotFoundImage />
                  <p>{message}</p>
                </div>
              </div>
            ) : (
              ""
            )}
          </div>
        ) : (
          ""
        )}
      </section>
    </>
  );
};
export default LPSurveyTableComp;
